import { render, staticRenderFns } from "./PositionDetail.vue?vue&type=template&id=c9a1ae4a"
import script from "../../controllers/position/position-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/position/position-detail.js?vue&type=script&lang=js&external"
import style0 from "./PositionDetail.vue?vue&type=style&index=0&id=c9a1ae4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports